var uiPagination = {
	caption: "Pagination",
	page: "Page {page}",
	first: "Première page",
	previous: "Page précédente",
	next: "Page suivante",
	last: "Dernière page"
};
var fr = {
	uiPagination: uiPagination
};

export { fr as default, uiPagination };
